module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "CouponCartView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CouponCartView!./src/pages/Shop/Member/Wallet/Coupon/CouponCart/index.js
// module id = 1074
// module chunks = 438